module.exports = __webpack_public_path__ + "img/sc-4p-2024.8adfdb5b.png";